import React, { useEffect, useRef } from "react";

import { gsap } from 'gsap';
import { MotionPathPlugin } from "gsap/MotionPathPlugin";
import classNames from "classnames";

import useResize from "~/hooks/useResize";

gsap.registerPlugin(MotionPathPlugin);


const Paper = ({trigger, colors, index})=> {

  const delta  = 100;

  const [containerWidth, containerHeight] = useResize();
  const confetiRef                        = useRef();

  useEffect(()=> {
    trigger && confetti();
  }, [trigger]);

  const confetti = ()=> {

    const div = confetiRef.current;

    gsap.to(div, { skewX  : getRandomNumber(-30, 30) + "deg" });
    gsap.to(div, { skewY  : getRandomNumber(-30, 30) + "deg" });
    gsap.to(div, { scaleX : getRandomNumber(5, 20) / 10});
    gsap.to(div, { scaleY : getRandomNumber(5, 20) / 10 });


    // Animation motion path
    const firstPathResult = generateFirstPath();
    const lastPathResult  = generateLastPath(firstPathResult.endPoint);

    const firstPath = firstPathResult.path;
    const lastPath = lastPathResult;

    const firstTime = getRandomNumber(500, 1500, 100) / 1000;
    let lastTime    = 2 * Math.min(Math.abs(firstPathResult.endPoint[1] / containerHeight), 0.8) + getRandomNumber(-5, 5) / 10;
    lastTime        = Math.max(firstTime, lastTime);

    new gsap.timeline()
      .to(div, {
        duration: firstTime,
        motionPath: { path: firstPath, type: "cubic" },
        ease: "power1.out",
        rotationY: "+=" + getRandomNumber(360, 1080),
        rotationX: "+=" + getRandomNumber(360, 1080)
      })
      .to(div, {
        duration: lastTime,
        motionPath: { path: lastPath, type: "cubic" },
        ease: "power1.in",
        rotationY: "+=" + getRandomNumber(360, 1080),
        rotationX: "+=" + getRandomNumber(360, 1080),
        onComplete:  ()=> div.remove()
      });
  };

  function generateFirstPath() {

    const startPoint = [getRandomNumber(-delta, 0), getRandomNumber(0, delta)];
    const endPointY  = getRandomNumber(-containerWidth * 4 / 5, 20);

    const endPointX  = (Math.abs(endPointY) > containerHeight / 2)
      ? getRandomNumber(containerWidth / 4, containerWidth * 3 / 4)
      : getRandomNumber(0, containerWidth * 4 / 5);

    const endPoint = [endPointX, endPointY];

    const controlPoint1 = [
      getRandomNumber(startPoint[0] - delta / 2, startPoint[0]),
      getRandomNumber(startPoint[1] + delta, startPoint[1] + 2 * delta)
    ];
    const controlPoint2 = [
      getRandomNumber(endPoint[0] - delta / 2, endPoint[0]),
      getRandomNumber(endPoint[1] - 2 * delta, endPoint[1] - delta)
    ];

    return {
      endPoint,
      path: `M ${startPoint.join(",")} C ${controlPoint1.join(",")} ${controlPoint2.join(",")} ${endPoint.join( ",")}`,
    };
  };

  function generateLastPath(startPoint) {

    const endPointX = (Math.abs(startPoint[1]) > containerHeight / 2)
      ? getRandomNumber(startPoint[0] + delta, startPoint[0] + 3 * delta)
      : getRandomNumber(startPoint[0] - delta / 2, startPoint[0] + 2 * delta);

    const endPoint = [endPointX, getRandomNumber(0, delta)];
    const controlPoint1 = [
      getRandomNumber(startPoint[0] - delta, startPoint[0] + delta),
      getRandomNumber(startPoint[1], startPoint[1] + 2 * delta)
    ];
    const controlPoint2 = [
      getRandomNumber(endPoint[0] - delta, endPoint[0] + delta),
      getRandomNumber(endPoint[1] - 2 * delta, endPoint[1])
    ];

    return `M ${startPoint.join(",")} C ${controlPoint1.join(",")} ${controlPoint2.join(",")} ${endPoint.join( ",")}`;
  };

  function getRandomNumber(start, end, step = 1) {
    const numberOfVariants = Math.floor((end - start) / step + 1);
    return Math.floor(Math.random() * numberOfVariants) * step + start;
  };

  const style = {
    background: colors[getRandomNumber(0, colors.length - 1)],
    filter : `blur(${Math.abs(index/50 - 2)}px)`,
    //transform  : `matrix(${getRandomNumber(5, 20) / 10}, ${getRandomNumber(-30, 30)}, ${getRandomNumber(-30, 30)}, ${getRandomNumber(5, 20) / 10})`,
  };

  return (
    <div ref={confetiRef} className={classNames("paper", {pop: trigger})} style={style} />
  );
};


export default Paper;
